import React, { Component } from "react";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import { connect } from "react-redux";
import EndpointList from "./endpointList";
import EndpointTable from "./endpointTable";
import ACLForm from "./aclForm";
import ReleaseNoteForm from "./releaseNotes/releaseNotesForm";
import DevelopersToolsForm from "./developersTools/devlopersToolsForm";
import PreferencesForm from "./preferences/preferencesForm";
import { CSSTransition } from "react-transition-group";
import sidebars from "../config";
import { fetchEndpointIfNeeded } from "../actions/fetch";
import { getEndpointCount } from "../actions/pages";
import NotFoundPage from "./notFoundPage";
import ProcessingSummary from "./dashboard/taskviewsection/ProcessingSummary";
import FailedSummary from "./dashboard/taskviewsection/FailedSummary";
import CompletedSummary from "./dashboard/taskviewsection/CompletedSummary";
import ChangePassword from "./changepassword/ChangePassword";
// import UserPreference from '../pages/UserPreference';
import UserPreference from "../pages/UserPreference/index"
import AboutExcelymio from "./AboutExcelymio";

import {
	BrowserView,
	MobileView,
	isBrowser,
	isMobile,
} from "react-device-detect";

class Main extends Component {
	createRoute(s) {
		if (
			s.config.adminOnly &&
			this.props.auth.user &&
			!this.props.auth.user.isAdmin
		) {
			return null;
		}
		if (
			this.props.auth.authenticated === true &&
			this.props.auth.user.emailVerified === null
		) {
			this.props.location.pathname = "/change-password";
		} else {
			let e = React.createElement;
			let vtyp = s.config.viewType;

			let comps = {
				EndpointList,
				EndpointTable,
				ACLForm,
				ReleaseNoteForm,
				DevelopersToolsForm,
				PreferencesForm,
			};

			let routes = [];
			let routePath = s.label.toLowerCase();
			routes.push(
				<Route
					key={s.id}
					path={"/" + routePath}
					render={() => e(comps[vtyp], { sidebar: s })}
				/>
			);
			s.children.forEach((c) => routes.push(this.createRoute(c)));

			return routes;
		}
	}

	componentDidMount() {
		let { dispatch, endpoints, auth } = this.props;
		endpoints.forEach((ep) => {
			if ((ep.name == 'preferences') || (ep.name == 'datasources')) {
				dispatch(fetchEndpointIfNeeded(ep.id))
			}
		});
	}

	breadCrumb = () => {
		let breadCrumb = window.location.href.split("/");
		return breadCrumb;
	};

	render() {
		return (
			<CSSTransition
				in={true}
				appear={true}
				timeout={4000}
				classNames="fade"
			>
				<div id="main-content">
					<div>
						<div>
							<Switch>
								{this.props.auth.user.emailVerified ? (
									<Route
										exact
										path="/"
										component={Dashboard}
									/>
									
								) : (
									<Route
										exact
										path="/"
										render={() => (
											<Redirect to="/change-password" />
										)}
									/>
								)}
								{isMobile
									? ""
									: sidebars.map((s) => this.createRoute(s))}
								<Route
									exact
									path="/tasks/completed"
									component={CompletedSummary}
								/>
								<Route
									exact
									path="/tasks/processing"
									component={ProcessingSummary}
								/>
								<Route
									exact
									path="/tasks/failed"
									component={FailedSummary}
								/>
								<Route
									exact
									path="/user-preference"
									component={UserPreference}
								/>
								<Route
									exact
									path="/change-password"
									component={ChangePassword}
								/>
								<Route
									exact
									path="/about-excelymio"
									component={AboutExcelymio}
								/>
								<Route component={NotFoundPage} />
							</Switch>
							{/* {this.props.auth.user.emailVerified ? <Redirect to='/' /> : <Redirect to='/change-password' />} */}
						</div>
						{/* <div className="footer-brand">
                            <span className="app-name">EYM.IO is a product of Excelym LLC</span>
                            <span className="version">v1.0.0</span>
                        </div> */}
					</div>
				</div>
			</CSSTransition>
		);
	}
}

function mapStateToProps(state) {
	return {
		endpoints: state.endpoints,
		auth: state.auth,
	};
}

export default withRouter(connect(mapStateToProps)(Main));



// WEBPACK FOOTER //
// ./src/components/main.js